<template>
  <div class="companies">
    <SectionHeader :title="$t('meta.overview')" />
    <div class="body-content cf">
      <CompanyNav />
      <div class="body">
        <Form @submit="updateCompany" :bodyClass="''" :title="$t('meta.baseData')">
          <FormInput :name="$t('meta.name')" v-model="company.name" />
          <FormSelect
            :name="$t('companies.companyType')"
            v-model="company.company_type"
            disabled
            :options="[
              { label: $t('companies.companyTypeBranch'), value: 'branch' },
              { label: $t('companies.companyTypeIndustry'), value: 'industry' },
            ]"
            required
          />
          <Button type="submit" fullWidth>{{ $t('companies.saveCompany') }}</Button>
        </Form>
        <CompanyLocations :companyUuid="companyUuid" />
        <CompanyUsers :companyUuid="companyUuid" />
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/Button'
import CompanyLocations from '@/components/Companies/CompanyLocations'
import CompanyUsers from '@/components/Companies/CompanyUsers'
import Form from '@/components/Form'
import FormInput from '@/components/Form/Input'
import FormSelect from '@/components/Form/Select'
import SectionHeader from '@/components/SectionHeader'
import CompanyNav from '@/components/company_nav'

import companiesApi from '@/api/companies'

export default {
  name: 'CompanyDetails',
  inject: ['companyUser'],
  data() {
    return {
      company: { ...this.companyUser.company },
      locations: [],
    }
  },
  components: {
    Button,
    CompanyNav,
    CompanyLocations,
    CompanyUsers,
    Form,
    FormInput,
    FormSelect,
    SectionHeader,
  },
  computed: {
    companyUuid() {
      return this.company.uuid
    },
  },
  methods: {
    updateCompany: async function () {
      await companiesApi.update(this.company.uuid, this.company)
    },
  },
}
</script>
